<template>
    <van-popup
        v-if="clockInPopupShow"
        :value="clockInPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', height: '434px', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="bottom"
    >
        <div class="custom_clockIn_wrap">
            <div class="custom_clockIn_title">
                <span>单次打卡</span>
                <i class="iconfont icon-guanbi" @click="handleClockInClose"></i>
            </div>
            <div class="custom_clockIn_card">
                <div class="time_wrap">
                    <h5>{{ formattedTime }}</h5>
                    <p>
                        <span>{{ getWeekday }}</span>
                        <span>{{ formattedDate }}</span>
                    </p>
                </div>
                <div class="address_wrap">
                    <p>
                        <i class="iconfont icon-weizhi1"></i>
                        <span class="ellipsis_2">{{ locationName || "定位失败" }}</span>
                    </p>
                </div>
            </div>
            <p class="custom_clockIn_txt">
                <i class="iconfont icon-shuaxin"></i>
                <span @click="handleClickUpdateClock">更改定位</span>
            </p>
            <div class="btns">
                <van-button type="info" @click="handleClickClockIn">打卡</van-button>
            </div>
        </div>
        <!-- 打卡成功弹框 -->
        <van-popup
            v-model="clockInSuccessPopup"
            closeable
            round
            position="bottom"
            @close="handleClockInSuccessPopupClose"
            :style="{ height: '434px' }"
        >
            <div class="clockIn_success_wrap">
                <div class="clockIn_success_icon">
                    <img
                        src="https://download.hecoos.com/enlightv/2024-52/ee3c2949285252c3cf0839120c8a21d8.png"
                        alt=""
                    />
                    <p>打卡成功</p>
                </div>
                <div class="cell_group_wrap">
                    <div>
                        <div class="cell_group_label">
                            <i class="iconfont icon-messgae-clock"></i><span>开始时间</span>
                        </div>
                        <div>
                            <span>{{ clockInForm.punch_at }}</span>
                        </div>
                    </div>
                    <div>
                        <div class="cell_group_label"><i class="iconfont icon-weizhi1"></i><span>位置</span></div>
                        <div>
                            <span>{{ clockInForm.locationName }}</span>
                        </div>
                    </div>
                    <div>
                        <div class="cell_group_label"><i class="iconfont icon-tupian"></i><span>照片</span></div>
                        <div class="upload_img_wrap">
                            <div class="item_img" v-for="(imgItem, imgIndex) in clockInForm.images" :key="imgIndex">
                                <img :src="imgItem" alt="" />
                                <i class="iconfont icon-guanbi1" @click="handleClickImgDelete(imgIndex)"></i>
                            </div>
                            <div
                                class="upload_icon"
                                v-if="clockInForm.images.length < 5"
                                @click="handleClickSelectUploadType"
                            >
                                <i class="iconfont icon-xiangji"></i>
                                <!-- <input
                                    type="file"
                                    @change="handleClickUploadFile"
                                    accept="image/png,image/jpeg,image/gif,image/jpg"
                                /> -->
                            </div>
                        </div>
                    </div>
                    <div class="flex_column">
                        <div class="cell_group_label"><i class="iconfont icon-bianji"></i><span>备注</span></div>
                        <div>
                            <van-field
                                v-model="clockInForm.remark"
                                rows="3"
                                autosize
                                label=""
                                type="textarea"
                                placeholder="请输入"
                                @input="debouncedHandleInput"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- 选择照片上传方式 -->
        <van-action-sheet v-model="imageActionSheetShow" cancel-text="取消" @cancel="handleCancelImage">
            <template #default>
                <div class="van-action-sheet__item ta-c" v-for="item in imageActions" @click="handleSelectImage(item)">
                    <span v-text="item.name"></span>
                    <input
                        type="file"
                        @change="handleClickUploadFile"
                        v-if="item.value == 1"
                        capture="camera"
                        accept="image/png,image/jpeg,image/gif,image/jpg"
                    />
                    <input
                        type="file"
                        @change="handleClickUploadFile"
                        v-if="item.value == 2"
                        accept="image/png,image/jpeg,image/gif,image/jpg"
                    />
                </div>
            </template>
        </van-action-sheet>
        <!-- 更改定位 -->
        <van-popup v-model="updateClockPopup" :overlay="false" position="bottom" :style="{ height: '100%' }">
            <div class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar
                        title="返回"
                        :isCustomReturnEvent="true"
                        :isTitleNormal="true"
                        :isAllFunctions="true"
                        @returnEvent="handleClickUpdateClockClose"
                    ></ReturnNavBar>
                </div>
                <div class="mobile_container">
                    <div class="update_clock_popup_content">
                        <p class="map_tip">可更改500米内的定位范围</p>
                        <div id="mapBox" style="width: 100%; height: 383px"></div>
                        <div>
                            <div class="cell_group_wrap">
                                <div>
                                    <div class="cell_group_label">
                                        <i class="iconfont icon-messgae-clock"></i><span>开始时间</span>
                                    </div>
                                    <div>
                                        <span>{{ formattedTime }}</span>
                                    </div>
                                </div>
                                <div>
                                    <div class="cell_group_label">
                                        <i class="iconfont icon-weizhi1"></i><span>位置</span>
                                    </div>
                                    <div>
                                        <span>{{ updateClockForm.locationName }}</span>
                                    </div>
                                </div>
                                <div>
                                    <div class="cell_group_label">
                                        <i class="iconfont icon-tupian"></i><span>照片</span>
                                    </div>
                                    <div class="upload_img_wrap">
                                        <div
                                            class="item_img"
                                            v-for="(imgItem, imgIndex) in updateClockForm.images"
                                            :key="imgIndex"
                                        >
                                            <img :src="imgItem" alt="" />
                                            <i
                                                class="iconfont icon-guanbi1"
                                                @click="handleClickImgDelete(imgIndex)"
                                            ></i>
                                        </div>
                                        <div
                                            class="upload_icon"
                                            v-if="updateClockForm.images.length < 5"
                                            @click="handleClickSelectUploadType"
                                        >
                                            <i class="iconfont icon-xiangji"></i>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="cell_group_label">
                                        <i class="iconfont icon-bianji"></i><span>备注</span>
                                    </div>
                                    <div>
                                        <van-field
                                            v-model="updateClockForm.remark"
                                            label=""
                                            type="input"
                                            placeholder="请输入"
                                            input-align="right"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="update_clock_btn">
                            <van-button type="info" @click="handleClickUpdateClockSubmit">打卡</van-button>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </van-popup>
</template>
<script>
import {
    CreateAttendanceCheck,
    GetIndividualDailyAttendanceCheck,
    UpdateAttendanceCheck,
    GetAttendanceCheckStatus,
} from "@/api";
import { getLocation, formatDate, getNowDate } from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import { uploadImg } from "@/utils/uploadOss";
import { ImagePreview } from "vant";
export default {
    name: "ClockInComponent",
    components: {ReturnNavBar},
    props: {
        clockInPopupShow: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            topTabActive: "SINGLE",
            currentTime: new Date(),
            location: "116.359767,40.073051",
            locationName: "首开国风美唐综合楼-3号楼",
            // 当前打卡成功后的id，在更新数据的时候使用
            currentClockId: "",
            // 打卡
            clockInSuccessPopup: false,
            // 打卡成功后的表单
            clockInForm: {
                punch_at: "",
                locationName: "",
                remark: "",
                images: [],
            },
            // 更改定位的表单
            updateClockForm: {
                locationName: "",
                location: "",
                is_skip: 0,
                remark: "",
                images: [],
            },
            // 更改定位
            updateClockPopup: false,
            selectedPosition: [116.397428, 39.90923],
            map: null,
            marker: null,
            // 上传图片方式
            imageActionSheetShow: false,
            imageActions: [
                { name: "拍照", value: 1 },
                { name: "从手机相册选择", value: 2 },
            ],
        };
    },
    computed: {
        formattedDate() {
            const dateObj = new Date();
            // 获取年、月、日
            const year = dateObj.getFullYear();
            const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
            const day = ("0" + dateObj.getDate()).slice(-2);
            return year + "." + month + "." + day;
        },
        formattedTime() {
            return formatDate(this.currentTime, "hourtime");
        },
        getWeekday() {
            const days = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
            const date = new Date();
            return days[date.getDay()];
        },
    },
    created() {
        this.debouncedHandleInput = this.debounce(this.handleInput, 500);
        this.getCurrentPosition();
    },
    mounted() {
        this.timer = setInterval(() => {
            this.currentTime = new Date();
        }, 1000);
    },
    methods: {
        handleClockInClose() {
            clearInterval(this.timer);
            this.$emit("update:clockInPopupShow", false);
        },
        // 备注输入回调
        handleInput(event) {
            this.handleUpdateAttendanceCheck();
        },
        // 防抖
        debounce(func, wait) {
            let timeout;
            return function (...args) {
                const later = () => {
                    timeout = null;
                    func.apply(this, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },
        // 选择上传图片方式
        handleClickSelectUploadType() {
            this.imageActionSheetShow = true;
        },
        // 选择上传图片
        handleSelectImage(item) {},
        handleCancelImage() {},
        // 预览图片
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        // 删除图片
        handleClickImgDelete(index) {
            if (this.updateClockPopup) {
                this.updateClockForm.images.splice(index, 1);
            } else {
                this.clockInForm.images.splice(index, 1);
                this.$nextTick(() => {
                    this.handleUpdateAttendanceCheck();
                });
            }
        },
        // 上传照片
        handleClickUploadFile(e) {
            e.preventDefault();
            this.imageActionSheetShow = false;
            let that = this;
            const file = e.target.files[0];
            if (file) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    const _data = this.result;
                    let blob = that.dataURItoBlob(_data);
                    let file = new window.File([blob], "照片.jpg", { type: "image/jpeg" });

                    uploadImg(file)
                        .then((res) => {
                            if (that.updateClockPopup) {
                                // 更改定位弹框
                                that.updateClockForm.images.push(res.file_path);
                            } else {
                                that.clockInForm.images.push(res.file_path);
                                that.$nextTick(() => {
                                    that.handleUpdateAttendanceCheck();
                                });
                            }
                        })
                        .catch(() => {});
                };
            }
        },
        // base64转换为Blob
        dataURItoBlob(base64Data) {
            let byteString;
            if (base64Data.split(",")[0].indexOf("base64") >= 0) {
                byteString = atob(base64Data.split(",")[1]);
            } else {
                byteString = unescape(base64Data.split(",")[1]);
            }
            let mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
            let ia = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], { type: mimeString });
        },
        // 初始化地理位置
        getCurrentPosition() {
            let that = this;
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 100000, //超过10秒后停止定位，默认：无穷大
                    buttonOffset: new AMap.Pixel(1, 2), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                });
                // map.addControl(geolocation);
                geolocation.getCurrentPosition(function (status, result) {
                    if (status === "complete") {
                        that.onComplete(result);
                    } else {
                        that.onError(result);
                    }
                });
            });
        },
        onComplete(data) {
            // 定位成功回调函数
            let lng = data.position.lng;
            let lat = data.position.lat;
            this.selectedPosition = [lng, lat];
            this.location = this.selectedPosition.join(",");
            this.convertToAddress(lng, lat).then((res) => {
                this.locationName = res;
                if (this.updateClockPopup) {
                    this.updateClockForm.locationName = this.locationName;
                }
            });
        },
        // 初始化地图
        async initMap() {
            // 初始化地图
            this.map = new AMap.Map("mapBox", {
                resizeEnable: true,
                zoom: 18, // 缩放级别
                center: this.selectedPosition || [116.397428, 39.90923], // 默认中心点（北京）
            });
            let that = this;
            // 获取用户当前位置
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 100000, //超过10秒后停止定位，默认：无穷大
                    buttonOffset: new AMap.Pixel(1, 2), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                });
                // map.addControl(geolocation);
                geolocation.getCurrentPosition(function (status, result) {
                    if (status === "complete") {
                        that.onComplete(result);
                    } else {
                        that.onError(result);
                    }

                    setTimeout(() => {
                        that.marker = new AMap.Marker({
                            position: that.selectedPosition,
                            map: that.map,
                            draggable: true, // 允许拖拽
                        });

                        // 监听标记拖拽事件
                        that.marker.on("dragend", (event) => {
                            console.log(event, "event===");
                            const { lng, lat } = event.lnglat;
                            that.selectedPosition = [lng, lat];
                            that.updateClockForm.location = this.selectedPosition.join(",");
                            that.onComplete({ position: { lng, lat } });
                        });
                    });
                });
            });
        },
        // 获取当前定位位置
        onError(result) {
            this.$toast("定位当前位置失败");
        },
        // 将经纬度转换为详细的地址
        async convertToAddress(longitude, latitude) {
            try {
                //这里的key修改为自己申请的key
                var response = await fetch(
                    `https://restapi.amap.com/v3/geocode/regeo?key=fc197e0057f33f3d1c6cfb50f33b9e3d&location=${longitude},${latitude}`
                );
                var data = await response.json();
                // 返回详细地址方法
                // if (data && data.regeocode && data.regeocode.formatted_address) {
                //     return data.regeocode.formatted_address; // 返回具体地址
                // } else {
                //     return "地址获取失败";
                // }
                // 返回指定信息
                if (data && data.regeocode && data.regeocode.addressComponent) {
                    const addressComponentInfo = data.regeocode.addressComponent;
                    // ${addressComponentInfo.district}
                    return `${addressComponentInfo.township}${
                        addressComponentInfo.streetNumber && addressComponentInfo.streetNumber.street
                    }${addressComponentInfo.streetNumber && addressComponentInfo.streetNumber.number}`;
                } else {
                    return "地址获取失败";
                }
            } catch (error) {
                return "地址获取发生错误";
            }
        },
        // 更改定位
        handleClickUpdateClock() {
            this.updateClockForm.location = this.selectedPosition.join(",");
            
            this.updateClockPopup = true;
            this.$nextTick(() => {
                this.initMap();
            });
        },
        // 直接打卡
        async handleClickClockIn() {
            let params = {
                punch_type: this.topTabActive,
                location: this.location,
                address: this.locationName,
                is_skip: 0,
                remark: [],
                images: [],
            };
            this.clockInForm.punch_at = this.formattedTime;
            this.clockInForm.locationName = this.locationName;
            CreateAttendanceCheck(params).then((res) => {
                if (res.code == 200) {
                    this.currentClockId = res.data.id;
                    this.clockInSuccessPopup = true;
                }
            });
        },
        // 更新本次打卡记录数据
        handleUpdateAttendanceCheck() {
            const params = {
                id: this.currentClockId,
                remark: this.clockInForm.remark ? [this.clockInForm.remark] : [],
                images: this.clockInForm.images,
            };
            UpdateAttendanceCheck(params).then((res) => {
                if (res.code === 200) {
                    // this.$toast(res.message);
                    // this.getIndividualDailyAttendanceCheck()
                }
            });
        },
        // 更改定位提交打卡
        handleClickUpdateClockSubmit() {
            let params = {
                punch_type: this.topTabActive,
                location: this.updateClockForm.location,
                address: this.updateClockForm.locationName,
                is_skip: this.updateClockForm.is_skip,
                remark: this.updateClockForm.remark ? [this.updateClockForm.remark] : [],
                images: this.updateClockForm.images,
            };
            console.log(params, "params===");
            CreateAttendanceCheck(params).then((res) => {
                if (res.code == 200) {
                    this.$toast("打卡成功");
                    this.updateClockPopup = false;
                    // this.getIndividualDailyAttendanceCheck();
                }
            });
        },
        // 打卡成功关闭
        handleClockInSuccessPopupClose() {
            this.clockInSuccessPopup = false;
            this.clockInForm.images = [];
            this.clockInForm.remark = "";
        },
        // 更改定位成功关闭
        handleClickUpdateClockClose() {
            this.updateClockPopup = false; 
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    background-color: #ffffff;
}
.custom_clockIn_wrap {
    width: 100%;
    height: 100%;
    padding: 16px;
    position: relative;
    box-sizing: border-box;
    border-radius: 8px 8px 0px 0px;
    background: rgba(250, 250, 250, 1);
    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
    .custom_clockIn_title {
        position: relative;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: rgba(51, 51, 51, 1);
        .iconfont {
            position: absolute;
            top: 4px;
            right: 0;
        }
    }
    .custom_clockIn_card {
        margin-top: 24px;
        height: 105px;
        padding: 10px;
        box-sizing: border-box;
        background-color: #ffffff;
        .time_wrap {
            width: 100%;
            display: flex;
            justify-content: space-between;
            gap: 20px;
            h5 {
                font-size: 36px;
                font-weight: 700;
                letter-spacing: 0px;
                height: 48px;
                line-height: 52px;
                color: rgba(0, 0, 0, 1);
            }
            p:nth-child(2) {
                padding: 2px 0;
                span {
                    display: block;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(153, 153, 153, 1);
                    text-align: right;
                }
            }
        }
        .address_wrap {
            margin-top: 20px;
            height: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            p:nth-child(1) {
                flex: 1;
                display: flex;
                align-items: center;
                gap: 4px;
                color: rgba(51, 51, 51, 1);
                .iconfont {
                    font-size: 20px;
                }
                span {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                }
            }
        }
    }
    .custom_clockIn_txt {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        color: rgba(41, 144, 240, 1);
        .iconfont {
            font-size: 12px;
        }
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
        }
    }
    .btns {
        position: absolute;
        left: 16px;
        right: 16px;
        bottom: 16px;
        text-align: center;
        .van-button {
            width: 112px;
            height: 38px;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 700;
            background-color: rgba(41, 144, 255, 0.8);
            border: none;
            &:active {
                background-color: rgba(41, 144, 255, 0.6);
            }
        }
    }
}
.clockIn_success_wrap {
    width: 100%;
    height: 100%;
    border-radius: 8px 8px, 0px, 0px;
    background: rgba(250, 250, 250, 1);
    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
    padding: 30px 16px 10px;
    .clockIn_success_icon {
        text-align: center;
        img {
            width: 74px;
            height: auto;
        }
        p {
            margin-top: 14px;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
    }
}
.cell_group_wrap {
    margin-top: 14px;
    border-radius: 8px;
    background-color: #ffffff;
    & > div {
        padding: 12px 10px;
        border-bottom: 1px solid rgba(250, 250, 250, 1);
        display: flex;
        justify-content: space-between;
        gap: 12px;
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
        }
        .cell_group_label {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            gap: 6px;
            .iconfont {
                font-size: 16px;
            }
        }
    }
    .flex_column {
        flex-direction: column;
        gap: 0;
        .van-cell {
            padding: 12px 0 0 20px;
            ::v-deep {
                textarea {
                    height: 66px !important;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }
            }
        }
    }
    .upload_img_wrap {
        display: flex;
        gap: 10px;
        .item_img_wrap {
            width: 30px;
            height: 30px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .upload_icon {
            position: relative;
            width: 30px;
            height: 30px;
            opacity: 1;
            border-radius: 4px;
            background: rgba(247, 248, 250, 1);
            display: flex;
            justify-content: center;
            align-items: center;
            .iconfont {
                color: rgba(102, 102, 102, 1);
                font-size: 16px;
            }
            input {
                position: absolute;
                width: 100%;
                height: 100%;
                opacity: 0;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
            }
        }
        .item_img {
            width: 30px;
            height: 30px;
            position: relative;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            .iconfont {
                position: absolute;
                top: -5px;
                right: -5px;
                font-size: 16px;
                color: rgba(153, 153, 153, 1);
                background-color: #ffffff;
                border-radius: 50%;
            }
        }
    }
}
.van-action-sheet__item {
    position: relative;
    input {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
}
.update_clock_popup_content {
    padding: 0 20px;
    .map_tip {
        padding: 0 0 10px 0;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        text-align: center;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
    .cell_group_wrap {
        & > div {
            padding: 12px 0;
        }
        ::v-deep {
            .van-cell {
                padding: 0;
            }
        }
    }
    .update_clock_btn {
        padding: 10px 0;
        .van-button {
            width: 100%;
            height: 38px;
            border-radius: 8px;
            background: rgba(25, 144, 255, 1);
        }
    }
}
</style>
<style lang="scss">
.van-image-preview__overlay {
    background: rgba(0, 0, 0, 0.3);
}
.van-image-preview {
    .van-image-preview__index {
        top: auto;
        bottom: 26px !important;
        text-shadow: none;
    }
}
</style>
